import React, { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import store from './redux/';
import * as serviceWorker from './serviceWorker';
import Config from './configure';
import 'react-perfect-scrollbar/dist/css/styles.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.scss"
import "./assets/fonts/feather/css/feather.css";
import "flag-icon-css/css/flag-icon.min.css";
import { loadPersistedUser } from './redux/actions/auth';


const App = lazy(() => import("./App/App"));

const rootElement = document.getElementById("root");

// Load persisted user (token) check
store.dispatch(loadPersistedUser());

if (rootElement) {
  const root = createRoot(rootElement);
  const appBasename = Config.basename && Config.basename !== '/' ? Config.basename : undefined;
  root.render(
    <Provider store={store}>
      {/* One toaster for the whole app: every toast.* call (services and screens) renders here. */}
      <Toaster richColors position="top-center" dir="rtl" />
      <BrowserRouter basename={appBasename}>
        <Suspense fallback={<div />}>
          <App />
        </Suspense>
      </BrowserRouter>
    </Provider>
  );
}


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
